import styles from '../../styles/Loader.module.css';

const ClientApplicationsSkeleton = () => {
    return(
        <div className={styles.skeletonClientApplications}>
            <div className={styles.skeletonClientApplicationsInner}>
                <div className={styles.skeletonClientApplicationsHeader}>
                    <div className={styles.skeletonClientApplicationsTitle}></div>
                    <div className={styles.skeletonClientApplicationsButton}></div>
                </div>
                {
                    [1,2].map((item) => (
                        <div key={item} className={styles.skeletonClientApplicationsBox}></div>
                    ))
                }
            </div>
        </div>
    )
}

export default ClientApplicationsSkeleton;